import { FC } from 'react';
import { Text } from '@hopskipdrive/react-components';
import { isAfter, parse, startOfToday } from 'date-fns';

import { ContentLabelContainer } from './ProfilePausedInfo.styles';

interface IProfilePauseInfo {
  pausedAt?: Nullable<string>;
  pausedUntil?: Nullable<string>;
}

export const ProfilePauseInfo: FC<IProfilePauseInfo> = ({ pausedAt, pausedUntil }) => {
  return (
    <>
      {pausedAt && <ContentLabel label={pausedAtLabel(pausedAt)}>{pausedAt}</ContentLabel>}
      {pausedUntil && <ContentLabel label={'Paused until'}>{pausedUntil}</ContentLabel>}
    </>
  );
};

const ContentLabel = ({ label, children, ...rest }) => {
  if (!children) {
    return null;
  }

  return (
    <ContentLabelContainer {...rest}>
      <Text variant="h3" textColor="secondaryText">
        {label}
      </Text>
      <Text textColor="secondaryText" fontWeight={300}>
        {children}
      </Text>
    </ContentLabelContainer>
  );
};

const pausedAtLabel = (pauseAt: string) => {
  const theDay = parse(pauseAt, 'M/d/yyyy', new Date());

  return isAfter(theDay, startOfToday()) ? 'Paused starting' : 'Paused since';
};
